<script>
  import {onMount} from 'svelte';
  import {fadeScale} from "../transition/fadeScale";
  import {MenuItem} from "../constants";
  import _ from 'lodash';

  export let items; // [{icon, text, action, color}, MenuItem.divider, ...]
  export let visible = false; // mouse position will be stored to prevent to use additional variable
  export let style = '';

  let containerElement;
  let wrapperTransform;

  const onContextMenu = e => {
    if (!visible) { // preventDefault only when contextmenu is not showing
      e.preventDefault();

      const parentTransforms = (() => {
        const res = {x: 0, y: 0};

        let current = containerElement;

        while (current.parentElement) {
          const transform = getComputedStyle(current).transform;
          if (transform !== 'none') {

            const regex = /matrix\(([\-0-9.]+),\s*([\-0-9.]+),\s*([\-0-9.]+),\s*([\-0-9.]+),\s*([\-0-9.]+),\s*([\-0-9.]+)\)/;
            const parsed = regex.exec(transform);

            res.x += parseInt(parsed[5]);
            res.y += parseInt(parsed[6]);
          }
          current = current.parentElement;
        }

        return res;
      })();

      wrapperTransform = `translate(${-parentTransforms.x}px, ${-parentTransforms.y}px)`;


      const x = e.layerX;
      const y = e.layerY;

      const targetRect = e.target.getBoundingClientRect();

      const showLeft = e.clientX > window.innerWidth * 0.8;
      const showTop = e.clientY > window.innerHeight * 0.8;

      visible = {
        left: showLeft ? 'auto' : x + 2, // add 2 to prevent the first item is shown when the menu appears
        top: showTop ? 'auto' : y + 2,
        right: showLeft ? targetRect.width - x + 2 : 'auto',
        bottom: showTop ? targetRect.height - y + 2 : 'auto'
      };

    } else {
      visible = false;
    }
  };

  const onMenuItemClick = action => {
    action && action();
    visible = false;
  };
</script>

<svelte:window on:mousedown={visible ? e => e.button === 0 && (visible = false) : null}/>

<div class="context-menu-container" style={style} on:contextmenu={onContextMenu} bind:this={containerElement}>
  <slot></slot>

  <div class="menu-wrapper" style="transform: {wrapperTransform}">
    {#if !!visible}
      <column
          class="context-menu"
          style={_.map(visible, (v, k) => `${k}: ${v}px;`).join('')}
          transition:fadeScale={{origin: {x: 0, y: 0}, duration: 150, scale: 0.9}}
      >
          {#each items as item}
              {#if item === MenuItem.divider}
                <div class="divider"></div>
              {:else}
                <row class="context-menu-item"
                     style="color: {item.color}"
                     on:mousedown={e => e.stopPropagation()}
                     on:click={() => onMenuItemClick(item.action)}
                >
                  <ion-icon name={item.icon}></ion-icon>
                    {item.text}
                </row>
              {/if}
          {/each}
      </column>
    {/if}
  </div>
</div>

<style>
  .context-menu-container {
    position: relative;
  }

  .menu-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
  }

  .context-menu {
    pointer-events: auto;
    position: fixed;
    background-color: #fafafa;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
    z-index: 2;
  }

  .context-menu-item {
    cursor: pointer;
    padding: 8px 12px;
  }

  .context-menu-item:hover {
    background-color: #eee;
  }

  .context-menu-item ion-icon {
    margin-right: 8px;
  }


  .divider {
    height: 1px;
    background-color: #eee;
  }
</style>

